import React from "react"

import { Box } from "@chakra-ui/react"

const Background = () => {
  return (
    <Box
      bg="#EDF5F7"
      position="absolute"
      top={0}
      bottom={0}
      left={0}
      zIndex={-2}
      sx={{
        right: 0,
        "@media (min-width: 1000px)": {
          right: "calc(50% - 8rem)",
        },
        "@media (min-width: 1100px)": {
          right: "calc(50% - 10rem)",
        },
        "@media (min-width: 1200px)": {
          right: "calc(50% - 14rem)",
        },
        "@media (min-width: 1300px)": {
          right: "calc(50% - 15rem)",
        },
      }}
    />
  )
}

export default Background
